import { render, staticRenderFns } from "./PanelWrapper.vue?vue&type=template&id=fc0f7474"
import script from "./PanelWrapper.vue?vue&type=script&lang=js"
export * from "./PanelWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports